import { isEmpty } from "lodash/fp";

import { get, patch } from "@app/common/api";
import {
  optionalParseUTCDateTimeFromString,
  parseUTCDateTime,
} from "@app/utils/utils";

import type {
  ApiUserEventGroup,
  UserEventGroupPatchRequest,
  UserEventGroup,
} from "../types/eventGroupTypes";

export const getUserEventGroups = async (): Promise<UserEventGroup[]> => {
  const events: ApiUserEventGroup[] = await get("/user-event-groups", {
    withCreds: true,
  });

  if (isEmpty(events)) return [];

  return events.map((e) => ({
    ...e,
    endTime: parseUTCDateTime(e.endTime),
    canBeFlexible: e.canBeFlexible ?? true,
    isFlexible: e.isFlexible ?? false,
    isPrivate: e.isPrivate ?? false,
    lastFlexibleMove: optionalParseUTCDateTimeFromString(e.lastFlexibleMove),
    numAttendees: e.attendeeCount,
    recurringEventId: e.userRecurringEventId,
    sendMeetingRecapToMe: e.sendMeetingRecapToMe,
    sendMeetingRecapToParticipantsWithAccess:
      e.sendMeetingRecapToParticipantsWithAccess,
    startTime: parseUTCDateTime(e.startTime),
    summary: e.title ?? "Untitled Meeting",
  }));
};

export const patchUserEventGroup = async ({
  id,
  body,
}: UserEventGroupPatchRequest) => {
  return patch(`/user-event-groups/${id}`, body, { withCreds: true });
};

export const getUserEventGroupById = async (
  eventGroupId: string
): Promise<UserEventGroup> => {
  return get(`/user-event-groups/${eventGroupId}`);
};
